import {
  Routes,
  Route,
  Navigate,
  useSearchParams,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom'
import Home from './pages/Home'
import Profile from './pages/Profile'
import Reports from './pages/Reports'
import Delete from './pages/Delete'
import PrivateRoute from './components/PrivateRoute'
import ForgotPassword from './pages/ForgotPassword'
import Header from './components/Header'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css'
import './index.css'
import Portfolio from './pages/Portfolio'
import { useState } from 'react'
import { AuthContext } from './hooks/getAuth'
import { useEffect } from 'react'
import { useRef } from 'react'
import Admin from './pages/Admin'
import Subscribe from './pages/subscribe'
import Tutorial from './pages/Tutorial'
import CacheBuster from 'react-cache-buster'
import packageInfo from '../package.json'
import Spinner from './components/Spinner'
import UsersPage from './pages/enterprise/users'
import UserDetails from './pages/enterprise/users/user-details'
import AccountActivation from './pages/enterprise/account-activation'
import EnterpriseProvider from './pages/enterprise/enterprise-provider'
import GenerateReport from './pages/generate-report'
import Payments from './pages/enterprise/payments'
import BillingHistoryPage from './pages/enterprise/billing-history'
import PDFPage from './pages/pdf'
import GeneratingReport from './components/generating_report'
import SignInPage from './pages/sign-in/sign-in'
import TrialLimitModal from './components/trial-modal/trial-limit-modal'
function App() {
  const isProduction = process.env.NODE_ENV === 'production'
  const [searchParams] = useSearchParams()
  const [auth, setAuth] = useState(null)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  const [ranches, setRanches] = useState([])
  const [parcels, setParcels] = useState([])
  const [lnProperties, setLnProperties] = useState([])
  const [ranchParcels, setRanchParcels] = useState([])
  const [loopnetOriginalData, setLoopnetOriginalData] = useState([])

  const [apnSource, setApnSource] = useState({})
  const [apnLayer, setApnLayer] = useState({})
  const [apnOutlineLayer, setApnOutlineLayer] = useState({})
  const [apnLabelLayer, setApnLabelLayer] = useState({})

  const [ranchApnSource, setRanchApnSource] = useState({})
  const [ranchApnLayer, setRanchApnLayer] = useState({})
  const [ranchApnOutlineLayer, setRanchApnOutlineLayer] = useState({})
  const [ranchApnLabelLayer, setRanchApnLabelLayer] = useState({})

  const [selectedRanch, setSelectedRanch] = useState({})

  const [initialParcels, setInitialParcels] = useState([])
  const [initialApnSource, setInitialApnSource] = useState({})
  const [initialApnLayer, setInitialApnLayer] = useState({})
  const [initialApnOutlineLayer, setInitialApnOutlineLayer] = useState({})
  const [clickedGeojson, setClickedGeojson] = useState(null)

  const mapRef = useRef(null)
  const [mapBounds, setMapBounds] = useState([[], []])
  const [currentTab, setCurrentTab] = useState('home')

  const localAuth = localStorage.getItem('auth')
    ? JSON.parse(localStorage.getItem('auth'))
    : {}

  const freshRestart = () => {
    clearRanchSelection()
    setRanches([])
    setParcels([])
    setLnProperties([])
    setRanchParcels([])
    setLoopnetOriginalData([])
    setApnSource({})
    setApnLayer({})
    setApnOutlineLayer({})
    setApnLabelLayer({})
  }
  const clearRanchSelection = () => {
    setSelectedRanch({})
    setRanchApnLayer({})
    setRanchApnOutlineLayer({})
    setRanchApnLabelLayer({})
    setRanchApnSource({})
    setMapBounds([[], []])
  }
  // const
  const [joyrideRun, setJoyrideRun] = useState(false)
  const [firstLogin, setFirstLogin] = useState(false)

  const pathname = useLocation().pathname

  useEffect(() => {
    const now = new Date()
    if (localAuth && localAuth.sessionKey && localAuth.expiry > now.getTime()) {
      setAuth(localAuth)
      setIsLoggedIn(true)
    } else if (pathname.includes('generate-report')) {
    } else {
      localStorage.setItem('auth', JSON.stringify({}))
      setAuth(null)
      setIsLoggedIn(false)
    }
  }, [])

  const [generatingReport, setGeneratingReport] = useState(false)
  const [reportStatus, setReportStatus] = useState(null)

  const ranchId = searchParams.get('ranchId')
  const { ranchId: ranchIdParams } = useParams()
  const status = searchParams.get('status')

  useEffect(() => {
    if (Number(ranchId) > 0) {
      const decodedData = decodeURIComponent(status)
      const jsonData = JSON.parse(decodedData)
      setReportStatus(jsonData)
    }
  }, [status])

  useEffect(() => {
    if (Number(ranchId) > 0) {
      setGeneratingReport(true)
    } else {
      setGeneratingReport(false)
    }
  }, [ranchId])

  const navigate = useNavigate()
  const signInAsDemo = () => {
    // Remove stylesheets
    const now = new Date()
    // Define user credentials
    const userCredential = {
      sessionKey: 'a6cf9f6e-3341-4996-8d6a-83e826b67adf',
      name: 'Demo User',
      email: 'demo@hydrascore.com',
      tier: 'Demo',
      expiry: now.getTime() + 7200000,
      tutorial: true,
    }
    // Store in local storage and update app state
    localStorage.setItem('auth', JSON.stringify(userCredential))
    setAuth(userCredential) // Assuming setAuth is defined elsewhere in your code
    setIsLoggedIn(true) // Assuming setIsLoggedIn is defined elsewhere
    setJoyrideRun(userCredential.tutorial) // Assuming setJoyrideRun is defined elsewhere
    freshRestart() // Assuming freshRestart is defined elsewhere
    navigate('/tutorial') // Navigate to the home page after signing in as demo
  }
  // Trigger the function when the /demo route is visited
  useEffect(() => {
    if (window.location.pathname === '/demo') {
      signInAsDemo()
    }
  }, [])

  return (
    <CacheBuster
      currentVersion={packageInfo.version}
      isEnabled={isProduction} //If false, the library is disabled.
      isVerboseMode={true} //If true, the library writes verbose logs to console.
      loadingComponent={<Spinner />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
    >
      <>
        <style>
          {`
                body > iframe {
                display: none;
                }
            `}
        </style>
        <AuthContext.Provider
          value={{ auth, setAuth, isLoggedIn, setIsLoggedIn }}
        >
          {Object.keys(localAuth).length > 0 &&
            ![
              'sign-in',
              'sign-up',
              'forgot-password',
              'delete',
              'subscribe',
            ].includes(currentTab) && (
              <Header
                localAuth={localAuth}
                joyrideRun={joyrideRun}
                setJoyrideRun={setJoyrideRun}
              />
            )}
          <Routes>
            <Route path="/" element={<PrivateRoute localAuth={localAuth} />}>
              <Route
                path="/"
                element={
                  <Home
                    initialParcels={initialParcels}
                    setInitialParcels={setInitialParcels}
                    initialApnSource={initialApnSource}
                    setInitialApnSource={setInitialApnSource}
                    initialApnLayer={initialApnLayer}
                    setInitialApnLayer={setInitialApnLayer}
                    initialApnOutlineLayer={initialApnOutlineLayer}
                    setInitialApnOutlineLayer={setInitialApnOutlineLayer}
                    clickedGeojson={clickedGeojson}
                    setClickedGeojson={setClickedGeojson}
                    ranches={ranches}
                    setRanches={setRanches}
                    ranchParcels={ranchParcels}
                    setRanchParcels={setRanchParcels}
                    parcels={parcels}
                    setParcels={setParcels}
                    lnProperties={lnProperties}
                    setLnProperties={setLnProperties}
                    loopnetOriginalData={loopnetOriginalData}
                    setLoopnetOriginalData={setLoopnetOriginalData}
                    apnSource={apnSource}
                    apnLayer={apnLayer}
                    apnOutlineLayer={apnOutlineLayer}
                    apnLabelLayer={apnLabelLayer}
                    setApnSource={setApnSource}
                    setApnLayer={setApnLayer}
                    setApnOutlineLayer={setApnOutlineLayer}
                    setApnLabelLayer={setApnLabelLayer}
                    clearRanchSelection={clearRanchSelection}
                    ranchApnSource={ranchApnSource}
                    ranchApnLayer={ranchApnLayer}
                    ranchApnOutlineLayer={ranchApnOutlineLayer}
                    ranchApnLabelLayer={ranchApnLabelLayer}
                    setRanchApnSource={setRanchApnSource}
                    setRanchApnLayer={setRanchApnLayer}
                    setRanchApnOutlineLayer={setRanchApnOutlineLayer}
                    setRanchApnLabelLayer={setRanchApnLabelLayer}
                    selectedRanch={selectedRanch}
                    setSelectedRanch={setSelectedRanch}
                    mapRef={mapRef}
                    mapBounds={mapBounds}
                    setMapBounds={setMapBounds}
                    currentTab={currentTab}
                    setCurrentTab={setCurrentTab}
                    localAuth={localAuth}
                    firstLogin={firstLogin}
                    setFirstLogin={setFirstLogin}
                    joyrideRun={joyrideRun}
                    setJoyrideRun={setJoyrideRun}
                    freshRestart={freshRestart}
                  />
                }
              ></Route>
            </Route>
            <Route path="/demo" element={<div>Loading demo...</div>} />
            <Route
              path="/tutorial"
              element={<PrivateRoute localAuth={localAuth} />}
            >
              <Route
                path="/tutorial"
                element={
                  <Tutorial
                    ranches={ranches}
                    setRanches={setRanches}
                    ranchParcels={ranchParcels}
                    setRanchParcels={setRanchParcels}
                    parcels={parcels}
                    setParcels={setParcels}
                    lnProperties={lnProperties}
                    setLnProperties={setLnProperties}
                    loopnetOriginalData={loopnetOriginalData}
                    setLoopnetOriginalData={setLoopnetOriginalData}
                    apnSource={apnSource}
                    apnLayer={apnLayer}
                    apnOutlineLayer={apnOutlineLayer}
                    apnLabelLayer={apnLabelLayer}
                    setApnSource={setApnSource}
                    setApnLayer={setApnLayer}
                    setApnOutlineLayer={setApnOutlineLayer}
                    setApnLabelLayer={setApnLabelLayer}
                    clearRanchSelection={clearRanchSelection}
                    ranchApnSource={ranchApnSource}
                    ranchApnLayer={ranchApnLayer}
                    ranchApnOutlineLayer={ranchApnOutlineLayer}
                    ranchApnLabelLayer={ranchApnLabelLayer}
                    setRanchApnSource={setRanchApnSource}
                    setRanchApnLayer={setRanchApnLayer}
                    setRanchApnOutlineLayer={setRanchApnOutlineLayer}
                    setRanchApnLabelLayer={setRanchApnLabelLayer}
                    selectedRanch={selectedRanch}
                    setSelectedRanch={setSelectedRanch}
                    mapRef={mapRef}
                    mapBounds={mapBounds}
                    setMapBounds={setMapBounds}
                    currentTab={currentTab}
                    setCurrentTab={setCurrentTab}
                    localAuth={localAuth}
                    joyrideRun={joyrideRun}
                    setJoyrideRun={setJoyrideRun}
                    freshRestart={freshRestart}
                  />
                }
              ></Route>
            </Route>
            <Route
              path="/profile"
              element={<PrivateRoute localAuth={localAuth} />}
            >
              <Route
                path="/profile"
                element={
                  <Profile
                    currentTab={currentTab}
                    setCurrentTab={setCurrentTab}
                    setJoyrideRun={setJoyrideRun}
                    localAuth={localAuth}
                  />
                }
              ></Route>
            </Route>
            <Route
              path="/admin"
              element={<PrivateRoute localAuth={localAuth} />}
            >
              <Route
                path="/admin"
                element={
                  <Admin
                    localAuth={localAuth}
                    currentTab={currentTab}
                    setCurrentTab={setCurrentTab}
                  />
                }
              ></Route>
            </Route>
            <Route
              path="/sign-in"
              element={
                <SignInPage
                  currentTab={currentTab}
                  setJoyrideRun={setJoyrideRun}
                  setFirstLogin={setFirstLogin}
                  setCurrentTab={setCurrentTab}
                  freshRestart={freshRestart}
                />
              }
            ></Route>
            <Route
              path="/delete"
              element={
                <Delete
                  currentTab={currentTab}
                  setCurrentTab={setCurrentTab}
                  freshRestart={freshRestart}
                />
              }
            ></Route>

            <Route
              path="/subscribe"
              element={<PrivateRoute localAuth={localAuth} />}
            >
              <Route
                path="/subscribe"
                element={
                  <Subscribe
                    currentTab={currentTab}
                    setCurrentTab={setCurrentTab}
                    setJoyrideRun={setJoyrideRun}
                    setFirstLogin={setFirstLogin}
                  />
                }
              ></Route>
            </Route>

            <Route path="/pdf" element={<PrivateRoute localAuth={localAuth} />}>
              <Route path="/pdf" element={<PDFPage />}></Route>
            </Route>

            <Route
              path="/forgot-password"
              element={
                <ForgotPassword
                  currentTab={currentTab}
                  setCurrentTab={setCurrentTab}
                />
              }
            ></Route>
            <Route
              path="/portfolio"
              element={<PrivateRoute localAuth={localAuth} />}
            >
              <Route
                path="/portfolio"
                element={
                  <Portfolio
                    ranches={ranches}
                    setRanches={setRanches}
                    parcels={parcels}
                    lnProperties={lnProperties}
                    clearRanchSelection={clearRanchSelection}
                    selectedRanch={selectedRanch}
                    setSelectedRanch={setSelectedRanch}
                    localAuth={localAuth}
                    currentTab={currentTab}
                    setCurrentTab={setCurrentTab}
                  />
                }
              ></Route>
            </Route>
            <Route
              path="/reports"
              element={<PrivateRoute localAuth={localAuth} />}
            >
              <Route
                path="/reports"
                element={
                  <Reports
                    localAuth={localAuth}
                    currentTab={currentTab}
                    setCurrentTab={setCurrentTab}
                  />
                }
              ></Route>
            </Route>
            <Route
              path="/account-activation"
              element={<AccountActivation />}
            ></Route>
            <Route
              path="/generate-report/:token/:ranchId"
              element={<GenerateReport />}
            ></Route>
            <Route
              path="*"
              element={<PrivateRoute localAuth={localAuth} />}
            ></Route>

            <Route path="/enterprise" element={<EnterpriseProvider />}>
              {/* Redirect from /enterprise to /enterprise/user */}
              <Route
                index
                element={<Navigate to="/enterprise/user" replace />}
              />
              <Route element={<PrivateRoute localAuth={localAuth} />}>
                <Route index path="/enterprise/user" element={<UsersPage />} />
                <Route
                  index
                  path="/enterprise/user/:id"
                  element={<UserDetails />}
                />
                <Route path="/enterprise/payments" element={<Payments />} />

                <Route
                  path="/enterprise/billing-history"
                  element={<BillingHistoryPage />}
                />
              </Route>
            </Route>
          </Routes>
          <ToastContainer
            position="bottom-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />

          <TrialLimitModal />
        </AuthContext.Provider>
        {(generatingReport || ranchIdParams) && (
          <div className="z-[9999] opacity-100 fixed inset-0 bg-white flex items-center justify-center">
            <GeneratingReport
              isCompleted={reportStatus}
              isSuccess={reportStatus?.status === 'success'}
            />
          </div>
        )}
      </>
    </CacheBuster>
  )
}

export default App
